import { Component, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CommonModule } from "@angular/common";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import {
  ExternalpageSingle,
  externalpageImageTypes,
} from "../../class/externalpage-single";
import { FormService } from "../../shared/services/form.service";
import { LoaderComponent } from "../../core/loader/loader.component";
import { SafeHtmlPipe } from "../../pipe/pipe.safehtml";
import { inject } from "@angular/core";

interface ContactFormValue {
  fullName: string;
  emailAddress: string;
  contactFormMessage: string;
  phoneNumber: string;
  subject: string;
}

@Component({
  selector: "app-page-contact",
  templateUrl: "./page-contact.component.html",
  styleUrls: ["./page-contact.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    LoaderComponent,
    SafeHtmlPipe,
  ],
})
export class PageContactComponent extends ExternalpageSingle implements OnInit {
  override readonly maxRelatedDataItems = 6;
  override permalink = "contact";
  override externalpageImageTypes = externalpageImageTypes;

  private readonly formService = inject(FormService);
  private readonly fb = inject(FormBuilder);

  constructor() {
    super();
  }

  contactForm!: FormGroup;
  formSubmitted = false;
  formError = false;

  ngOnInit(): void {
    this.loadSingle("contact");
    this.initForm();
  }

  private initForm(): void {
    this.contactForm = this.fb.group({
      fullName: ["", Validators.required],
      emailAddress: ["", [Validators.required, Validators.email]],
      contactFormMessage: ["", Validators.required],
      phoneNumber: ["", Validators.required],
      subject: [""],
    });
  }

  onSubmitContactForm(): void {
    this.formSubmitted = true;

    if (!this.contactForm.valid) {
      this.formError = true;
      this.contactForm.markAllAsTouched();
      return;
    }

    this.formError = false;
    const formValue = this.contactForm.value as ContactFormValue;

    let message = "";
    if (formValue.phoneNumber) {
      message += `Tel: ${formValue.phoneNumber}<br />`;
    }
    if (formValue.subject) {
      message += `Onderwerp: ${formValue.subject}<br />`;
    }
    message += `Bericht:<br />${formValue.contactFormMessage}`;

    const params = {
      fullName: formValue.fullName,
      emailAddress: formValue.emailAddress,
      contactFormMessage: message,
    };

    this.formService
      .sendContactFormEmail(params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.contactForm.reset(),
        error: (err) => console.error("Form submission failed", err),
      });
  }
}
